import * as React from 'react'

export interface IPageNumber {
    number: number;
    active: boolean;
}

export interface IPageButton extends IPageNumber {
    isLeftMost: boolean;
    isRightMost: boolean;
    isEllipsis: boolean;
    numberOfPages: number;
}

interface IProps {
    page: IPageButton;
    onPageSelect(page: number): void;
}

interface IState {

}

/// <summary>
/// Individual page buttons
/// </summary>
export class PageButton extends React.Component<IProps, IState> {

    render() {
        const { active, isEllipsis, isLeftMost, isRightMost, number, numberOfPages } = this.props.page;

        // Is this an ellipsis?
        const content = isEllipsis
            ? '...'
            // What about the left most button?
            : isLeftMost
                ? 1
                // Right most button?
                : isRightMost
                    ? numberOfPages
                    // No just show the number
                    : number;

        // Is this button active?
        const divClass = active
            ? 'selected'
            // Or an ellipsis
            : isEllipsis
                ? 'ellipsis'
                // Nah
                : '';

        const onClick = () => isEllipsis ? false : this.props.onPageSelect(number);

        return (
            <div
                className={`${divClass} search-pagination-buttons-item search-pagination-buttons-item-${content}`}
                onClick={onClick} >
                <span dangerouslySetInnerHTML={{ __html: content.toString() }} />
            </div>
        );
    }


}